// NOREWYN AKADEMIET TYPER (V12.4)

export enum RoomType {
  HALLWAY = 'HALLWAY',
  POTIONS = 'POTIONS',
  HERBOLOGY = 'HERBOLOGY',
  ANCIENT_RUNES = 'ANCIENT_RUNES',
  GREAT_HALL = 'GREAT_HALL'
}

export type AccessLogic = 'AND' | 'OR';

export interface RoomAccessRule {
  id: string;
  roomId: string;
  allowedAges: string[];
  allowedGuilds: string[];
  allowedFellowships?: string[];
  allowedClassrooms?: string[];
  allowedSubjects?: string[];
  allowedUsers: string[];
  extraAllowedUserIds?: string[];
  blockedUserIds?: string[];
  logic: AccessLogic;
  isActive: boolean;
}

export interface WingAccessRule {
  id: string;
  wingId: string;
  allowedAges?: string[];
  allowedGuilds?: string[];
  allowedClassrooms?: string[];
  allowedUsers?: string[];
  logic: AccessLogic;
  isActive: boolean;
}

export interface Wing {
  displayOrder?: number;
  id: string;
  name: string;
  description?: string;
  themeUrl?: string;
  backgroundUrl?: string;
  roomIds: string[];
  lockedDisplay?: 'lock' | 'dim' | 'hide';
  createdAt?: number;
  isActive?: boolean;
}

export interface Player {
  id: string;
  name: string;
  wizardName?: string;
  realName?: string;
  email?: string;
  avatarUrl: string;
  role: 'student' | 'guardian' | 'admin' | 'superadmin' | 'observer';
  magicalLevel: number;
  xp?: number;
  allowedRooms: string[];
  ageGroup?: string;
  guild?: string;
  groupId?: string;
  classroomId?: string;
  subjectIds?: string[];
  classIds?: string[];
  // Pakkestruktur — tre niveauer:
  // basis    = grundadgang, begrænset Campus (kun se skema og dagbog)
  // standard = fuld Campus adgang inkl. vogterrullen
  // plus     = eksklusivt indhold, plus-skema poster, premium features
  campusPackage?: 'basis' | 'standard' | 'plus';
  hasHallsAccess?: boolean;
  isBanned?: boolean;
  isIdentityVerified?: boolean;
  identityStatus?: 'pending' | 'verified' | 'failed' | 'manual' | 'revoked';
  membershipStatus?: string;
  x: number;
  y: number;
  currentRoom: string;
  lastSeen: number;
}

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  text: string;
  timestamp: number;
  room: string;
}

export interface RoomData {
  displayOrder?: number;
  id: string;
  name: string;
  description: string;
  zoomMeetingId: string;
  imageUrl?: string;
  roomBackgroundUrl?: string;
  wingIds?: string[];
  side?: 'left' | 'right';
  slot?: number;
  isActive?: boolean;
  classroomId?: string;
  classroomIds?: string[];
  subjectIds?: string[];
  guestGuardianIds?: string[];
  visibleAdminIds?: string[];
  isPortalActive?: boolean;
  lockedDisplay?: 'lock' | 'dim' | 'hide';
}

export interface RoomNotice {
  id: string;
  roomId: string;
  authorName: string;
  text: string;
  timestamp: number;
  isImportant?: boolean;
}

export interface BriefingUpdate {
  id: string;
  timestamp: number;
  message: string;
  focusTitle?: string;
  focusLinkId?: string;
  focusLinkType?: string;
  homework?: string;
  link?: string;
}

export interface RoomBriefing {
  id: string;
  roomId: string;
  guardianId: string;
  guardianName: string;
  date: string;
  ritualTitle?: string;
  ritualTime?: string;
  subjectId?: string;
  subjectName?: string;
  updates: BriefingUpdate[];
  visibleTo: 'all' | 'plus' | string[];
  seenBy: string[];
  createdAt: number;
  updatedAt: number;
  expireAt: number;
}

export interface BoardData {
  guardianId: string;
  guardianName: string;
  subjectName?: string;
  isVisible?: boolean;
  lastUpdated?: number;
  linkedSubjectId?: string;
  linkedHallId?: string;
}

export interface RitualException {
  date: string;            // ISO-dato YYYY-MM-DD for den ramte forekomst
  cancelled?: boolean;     // spring denne forekomst over
  patch?: {                // eller: ret KUN denne dag
    time?: string;
    endTime?: string;
    title?: string;
    description?: string;
  };
}
export interface ScheduleRitual {
  id: string;
  day: 'Mandag' | 'Tirsdag' | 'Onsdag' | 'Torsdag' | 'Fredag' | 'Lørdag' | 'Søndag';
  time: string;
  endTime?: string;
  repeat?: 'none' | 'weekly' | 'daily';
  title: string;
  description: string;
  type: 'Lektion' | 'Ritual' | 'Samling' | 'Event';
  // Pakke-adgang: all = alle, plus = kun plus-pakke
  accessLevel?: 'all' | 'basis' | 'standard' | 'plus';
  isVisible?: boolean;
  hiddenUntil?: number;
  groupId?: string;
  sourceRoomId?: string;
  // NY: Elev-specifik synlighed
  // Hvis allowedStudentIds er sat OG ikke-tom, vises kun til de valgte elever
  // Hvis allowedAgeGroups er sat OG ikke-tom, vises kun til de valgte aldersgrupper
  // Begge kan kombineres — eleven skal matche ÉN af betingelserne (OR-logik)
  // Hvis begge er tomme/undefined gælder accessLevel-logikken som før
  allowedStudentIds?: string[];
  allowedAgeGroups?: string[];
  assignedGuardianId?: string;
assignedGuardianName?: string;
targetRoomId?: string;
vacationFrom?: number;
vacationUntil?: number;
  linkedSubjects?: { hallId: string; subjectId: string }[];
  // --- SERIE / GENTAGELSE (Trin 1 skema-byggeplan) ---
  // Alle valgfri. Mangler de, opfoerer ritualet sig som foer:
  // ugentlig, interval 1, uendelig. Ingen migrering noedvendig.
  repeatInterval?: number;              // hver X (dag/uge). Default 1
  seriesStart?: string;                 // ISO-dato YYYY-MM-DD. Anker for interval
  seriesEnd?: string;
  visibleInVacations?: boolean;   // vis trods skoleaars-ferie                   // ISO-dato YYYY-MM-DD. Valgfri slut
  exceptions?: RitualException[];       // enkelt-dags afvigelser
  classroomId?: string;
  classroomIds?: string[];
}